import React, { useState } from "react"

export default function InfoBox({
  title,
  children
}: {
  title?: string
  children: React.ReactNode
}) {
  //State für Sichtbarkeit des Tooltips
  const [visible, setVisible] = useState(false)

  return (
    <div
      className="relative inline-flex items-center ml-2"
      onMouseEnter={() => setVisible(true)} 
      onMouseLeave={() => setVisible(false)}
    >
      {/*Rundes Symbol*/}
      <span className="inline-flex items-center justify-center font-bold text-white bg-blue-500 rounded-full cursor-default w-3 h-3 text-xs leading-none">
        i
      </span>

      {/*Tooltip, der beim Hovern eingeblendet wird*/}
      {visible && (
        <div className="absolute z-10 text-left bg-blue-50 border border-blue-300 text-gray-800 text-sm rounded-md p-3 shadow-md w-72 top-6 left-1/2 -translate-x-1/2">
          {/*Titel*/}
          {title && <strong className="block text-gray-900 mb-1">{title}</strong>}

          {/*Text oder weiterer Inhalt*/}
          {children}
        </div>
      )}
    </div>
  )
}
